import { render, staticRenderFns } from "./adminContent.vue?vue&type=template&id=64e7982d"
import script from "./adminContent.vue?vue&type=script&lang=js"
export * from "./adminContent.vue?vue&type=script&lang=js"
import style0 from "./adminContent.vue?vue&type=style&index=0&id=64e7982d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VContent } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VContent})
